__turbopack_context__.v({
  "memberDrawer": "gTF-6q_memberDrawer",
  "memberDrawer__body": "gTF-6q_memberDrawer__body",
  "memberDrawer__email": "gTF-6q_memberDrawer__email",
  "memberDrawer__footer": "gTF-6q_memberDrawer__footer",
  "memberDrawer__footerActions": "gTF-6q_memberDrawer__footerActions",
  "memberDrawer__header": "gTF-6q_memberDrawer__header",
  "memberDrawer__name": "gTF-6q_memberDrawer__name",
  "memberDrawer__serviceTypeRow": "gTF-6q_memberDrawer__serviceTypeRow",
  "memberDrawer__serviceTypesBlock": "gTF-6q_memberDrawer__serviceTypesBlock",
  "memberDrawer__serviceTypesList": "gTF-6q_memberDrawer__serviceTypesList",
});
